




import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconLink extends Vue {
    @Prop({ type: Number, default: 36 }) readonly size!: number

}
